import { render, staticRenderFns } from "./ServiceBadge.vue?vue&type=template&id=5c26ac7e&scoped=true&"
import script from "./ServiceBadge.vue?vue&type=script&lang=js&"
export * from "./ServiceBadge.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBadge.vue?vue&type=style&index=0&id=5c26ac7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c26ac7e",
  null
  
)

export default component.exports